export enum EarconName {
  Drag = 'drag',
  Drop = 'drop',
  DrillDown = 'drillDown',
  DrillUp = 'drillUp',
  Error = 'error',
  InputFull = 'inputFull',
  Notification = 'notification',
  PopupClose = 'popupClose',
  PopupOpen = 'popupOpen',
  ProcessComplete = 'processComplete',
}

export interface EarconProps {
  /**
   * A source can be provided in two ways in order to load an audio file to play:
   * 1. Built in audio file referenced using the `EarconName` enum
   * 2. A local path to an audio file
   */
  source: EarconName | string | undefined;
}
